export enum oauthProviders {
    Slack = 10,
    WsLevelJira = 20,
    JiraOauth2 = 30,
    JiraOauth1 = 50,
    JiraOauth1Impersonation = 60,
    JiraOauth1Corporate = 70,
}

export interface OauthProvider {
    name: string;
    enumValue: number;
    oauthUrl: string;
}

const getUrlForProvider = (oauthProvider: oauthProviders): string => {
    return `${initAppData.appUrls.appUrl}/integrationsettings/openoauth?provider=${oauthProvider}`;
};

export const oauthProviderSettings = new Map<oauthProviders, OauthProvider>();

const setupProviders = () => {
    const currentOauthProviders = new Set<oauthProviders>();

    currentOauthProviders.add(oauthProviders.Slack);
    currentOauthProviders.add(oauthProviders.WsLevelJira);
    currentOauthProviders.add(oauthProviders.JiraOauth2);
    currentOauthProviders.add(oauthProviders.JiraOauth1);
    currentOauthProviders.add(oauthProviders.JiraOauth1Impersonation);
    currentOauthProviders.add(oauthProviders.JiraOauth1Corporate);

    for (const provider of currentOauthProviders) {
        oauthProviderSettings.set(provider, {
            name: oauthProviders[provider],
            enumValue: provider,
            oauthUrl: getUrlForProvider(provider),
        });
    }
};

setupProviders();
